<script lang="ts">
    function flipLanguages() {
        const translationPathPattern = new RegExp(
            "^/([a-z][a-z][a-z]|mis_[a-z][a-z][a-z]|[a-z][a-z])/([a-z][a-z][a-z]|mis_[a-z][a-z][a-z]|[a-z][a-z])/(.*)$"
        );
        const matched = window.location.pathname.match(translationPathPattern);
        if (matched === null) {
            return;
        }
        window.location.assign(`/${matched[2]}/${matched[1]}/${matched[3]}`);
    }

    window.addEventListener("keydown", (event: KeyboardEvent) => {
        if (event.ctrlKey && event.code === "Space") {
            flipLanguages();
        }
    });
</script>
